<script setup lang="ts">
  import { onMounted, onUnmounted } from "vue";
  import { RouterView, useRoute, useRouter } from 'vue-router';
  import Toast from "@/components/Toast.vue";
  import { useAppStore } from "@/stores/app";
  import Cookies from "@/components/Cookies.vue";
  import { captureUTMParams } from "./utils/utm";

  const appStore = useAppStore();
  const route = useRoute();
  const router = useRouter();

  onMounted(() => {
    window.addEventListener('resize', appStore.onResize);
    window.addEventListener('scroll', appStore.onScroll);

    // Capture UTM params on app load
    captureUTMParams();
  });
  onUnmounted(() => {
    window.removeEventListener('resize', appStore.onResize);
    window.removeEventListener('scroll', appStore.onScroll);
  });
</script>

<template>
  <v-app id="app">
    <router-view/>
    <Toast/>
    <Cookies/>
  </v-app>
</template>

<style lang="scss" scoped>
</style>
